/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

throw new Error("Module build failed: ModuleBuildError: Module build failed: \n@import '../../node_modules/breakpoint-sass/stylesheets/_breakpoint';\n^\n      File to import not found or unreadable: ../../node_modules/breakpoint-sass/stylesheets/_breakpoint.\n      in /Users/modestas/Sites/localhost/proptechlt/wp-content/themes/proptech-lithuania/src/scss/helpers/mixins.scss (line 1, column 1)\n    at /Users/modestas/Sites/localhost/proptechlt/wp-content/themes/proptech-lithuania/node_modules/webpack/lib/NormalModule.js:192:19\n    at /Users/modestas/Sites/localhost/proptechlt/wp-content/themes/proptech-lithuania/node_modules/loader-runner/lib/LoaderRunner.js:364:11\n    at /Users/modestas/Sites/localhost/proptechlt/wp-content/themes/proptech-lithuania/node_modules/loader-runner/lib/LoaderRunner.js:230:18\n    at context.callback (/Users/modestas/Sites/localhost/proptechlt/wp-content/themes/proptech-lithuania/node_modules/loader-runner/lib/LoaderRunner.js:111:13)\n    at Object.callback (/Users/modestas/Sites/localhost/proptechlt/wp-content/themes/proptech-lithuania/node_modules/sass-loader/lib/loader.js:55:13)\n    at Object.done [as callback] (/Users/modestas/Sites/localhost/proptechlt/wp-content/themes/proptech-lithuania/node_modules/neo-async/async.js:8077:18)\n    at options.error (/Users/modestas/Sites/localhost/proptechlt/wp-content/themes/proptech-lithuania/node_modules/node-sass/lib/index.js:293:32)");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

throw new Error("Module build failed: Error: ENOENT: no such file or directory, open '/Users/modestas/Sites/localhost/proptechlt/wp-content/themes/proptech-lithuania/node_modules/jquery/dist/jquery.js'");

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var _main = __webpack_require__(0);

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

$(function () {
    var windowsize = $(window).width();

    //menu toggle
    $('.burger-menu, .close, .menu a, .join .button').click(function () {
        $('.menu-wrap').toggleClass('open');
    });

    //menu
    //click anchor to scroll
    $('.menu-wrap a,.button.green').click(function (e) {
        if (this.hash && this.hash.length > 1) {
            // e.preventDefault();
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') || location.hostname == this.hostname) {

                var target = $(this.hash);

                target = target.length ? target : $('[id=' + this.hash.slice(1) + ']');
                if (target.length) {
                    $('html,body').animate({
                        scrollTop: target.offset().top - 80
                    }, 1000);
                    return false;
                }
            }
        }
    });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js